<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex justify-content-between catalogo-text"
          >
            Usuarios
            <router-link :to="{ name: 'NuevoUsuario' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Usuario
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div> -->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CInput
                  v-model="filter"
                  @input="searchTimeOut()"
                  placeholder="Búsqueda por usuarios..."
                />
              </template>
              <template #nombre="{item}">
                <td class="py-2 bg-custom">{{ item.nombre }}</td>
              </template>
              <template #email="{item}">
                <td class="py-2 bg-custom">{{ item.correo }}</td>
              </template>
              <template #edit="{item}">
                <td class="py-2 bg-custom">
                  <router-link
                    :to="{ name: 'EditarUsuario', params: { id: item.id } }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2 bg-custom">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #details="{item}">
                <CCardBody class="d-flex pb-1 pt-3">
                  <div class="listContainer-1">
                    <h6>Perfiles</h6>
                    <ul class="custom-list">
                      <li v-for="(p, index) in item.roles" :key="index">
                        {{ getPerfil(p) }}
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="listContainer-2">
                    <h6>Ubicaciones</h6>
                    <ul class="custom-list">
                      <li v-for="(p, index) in item.perfiles" :key="index">{{p.ubicacion}}</li>
                    </ul>
                  </div>-->
                </CCardBody>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Usuario"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar el usuario {{ itemModal.name }} ?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Usuario</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteUsuario(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
const fields = [
  { key: "nombre", label: "Nombre", _style: "width:50%" },
  { key: "email", label: "Correo", _style: "width:50%" },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Usuarios",

  data() {
    return {
      items: [],
      perfiles: [],
      cultivos: [],
      fields,
      filter: "",
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      error: "",
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.isLoading = true;
    const usu = [
      this.$store.dispatch("customUsuarioHTTP", { limit: 50, page: 1 }),
      this.$store.dispatch("customRolHTTP"),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      })
    ];

    Promise.all(usu)
      .then(([usuarios, perfiles, ubicaciones]) => {
        this.items = usuarios.data;
        this.pages = usuarios.paginate.last_page;
        this.page = usuarios.paginate.current_page;
        this.perfiles = perfiles.data;
        this.ubicaciones = ubicaciones.data;
      })

      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.items.filter(i =>
        i.correo.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customUsuarioHTTP", {
          limit: 50,
          page: 1,
          filter: {
            orwhere: [
              {
                field: "nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "correo",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customUsuarioHTTP", {
          limit: 50,
          page: event,
          filter: {
            orwhere: [
              {
                field: "nombre",
                operator: "like",
                value: `%${this.filter.toUpperCase()}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "correo",
                operator: "like",
                value: `%${this.filter.toUpperCase()}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)
        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    getPerfil(perfil_id) {
      // if (this.perfiles.includes(perfil_id)) {
      const perfilActual = this.perfiles.find(
        perfil => perfil.rol == perfil_id
      );
      if (perfilActual) {
        return perfilActual.rol;
      } else {
        return "";
      }
      // }
      // return "";
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.correo,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deleteUsuario(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customUsuarioEliminarHTTP", {
          usuario_id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.bg-custom {
  background-color: #e8e8e8 !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-list {
  list-style: none;
  padding-left: 0;
}
.listContainer-1 h6 {
  font-size: 1.1rem;
}
.listContainer-2 h6 {
  font-size: 1.1rem;
}
.listContainer-1 {
  padding-left: 1rem;
}
.listContainer-2 {
  padding-left: 10rem;
}
</style>
